const normalizeAddressText = (value) =>
  String(value || '')
    .replace(/\s+/g, '')
    .trim()

const normalizeAddressRecordName = (value) =>
  normalizeAddressText(value).replace(
    /^(จังหวัด|จ\.|อำเภอ|อ\.|เขต|ตำบล|ต\.|แขวง)/,
    '',
  )

const getAddressRecordName = (record = {}) =>
  record.name ||
  record.provinceName ||
  record.districtName ||
  record.subDistrictName ||
  record.subdistrictName ||
  ''

export const getSmartCardAddressText = (data = {}) =>
  [data.address, ...(Array.isArray(data.array_address) ? data.array_address : [])]
    .filter(Boolean)
    .join(' ')

export const getSmartCardHouseNumber = (data = {}) => {
  const firstAddressPart = Array.isArray(data.array_address)
    ? data.array_address.find((value) => /^\s*\d/.test(String(value || '')))
    : ''
  const addressValue = firstAddressPart || data.address || ''
  const matched = String(addressValue).match(
    /^\s*(?:บ้านเลขที่\s*)?([\d][^\s]*)/,
  )
  return matched?.[1] || ''
}

export const getSmartCardVillageCode = (data = {}) => {
  const matched = getSmartCardAddressText(data).match(
    /(?:หมู่ที่|หมู่)\s*(\d+)/,
  )
  return matched?.[1] || ''
}

export const findSmartCardAddressRecord = (
  records = [],
  addressText,
  prefixes = [],
) => {
  const normalizedAddress = normalizeAddressText(addressText)
  if (!normalizedAddress) return undefined

  return [...records]
    .sort(
      (left, right) =>
        normalizeAddressText(getAddressRecordName(right)).length -
        normalizeAddressText(getAddressRecordName(left)).length,
    )
    .find((record) => {
      const name = normalizeAddressRecordName(getAddressRecordName(record))
      if (!name) return false

      return prefixes.some((prefix) =>
        normalizedAddress.includes(`${normalizeAddressText(prefix)}${name}`),
      )
    })
}

export const getSmartCardAddressRecordName = getAddressRecordName
